<template>
    <span class="operating" @click.stop="operate">
      <i :class="['zmdi','fs16','zmdi-'+icon,'text-'+color]"></i>
    </span>
</template>

<script>
export default{
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'info'
    }
  },
  name: 'operating-button',
  data () {
    return {

    }
  },
  methods: {
    operate(e) {
      this.$emit('operate', e)
    }
  }
}
</script>

<style lang='scss' scoped>
.operating{
  display: inline-block;
  margin-top: 10px;
  line-height: 30px;
  text-align: center;
  width: 30px;
  height: 30px;
  background: #fff;
  border-radius: 50%;
  cursor:pointer;
  &:hover{
    box-shadow: 0 0 5px #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components-base/components-custom/operating-button/operating-button.vue